package gr.tech.GRAttestation.sections.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import gr.tech.GRAttestation.styles.noBorder
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun AdminTableContainer(
    modifier: Modifier = Modifier,
    adminTable: @Composable () -> Unit,
) {
    Box(
        modifier = Modifier
            .backgroundColor(Colors.WhiteSmoke)
            .noBorder()
            .border(1.px, LineStyle.Solid, Colors.LightGray)
            .borderRadius(8.px)
            .minWidth(100.percent)
            .overflow(
                overflowX = Overflow.Auto,
                overflowY = Overflow.Auto
            )
            .boxShadow(BoxShadow.of(
                offsetX = 0.px,
                offsetY = 10.px,
                blurRadius = 10.px,
                spreadRadius = 1.px,
                color = Color.rgba(0,0,0,0.1.toFloat())
            ))
            .then(modifier)
    ) {
        adminTable()
    }
}